'use client';

const sizeToFontVariant = {
  sm: "body.xs",
  base: "body.sm",
  lg: "body.lg",
  xl: "body.xl"
};
export {
  sizeToFontVariant
};
